import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/provider/etm'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class EtmApi {

    static async generateJob({ data = undefined, ...params }) {
        return await fetchService({ url: '/generatejob', method: 'POST', data, ...params })
    }

    static async uploadjob({ data = undefined, ...params }) {
        return await fetchService({ url: '/uploadjob', method: 'POST', data, ...params })
    }

    static async updateProducts({ data = undefined, ...params }) {
        return await fetchService({ url: '/updateproducts', method: 'POST', data, ...params })
    }

    static async updateStocks({ data = undefined, ...params }) {
        return await fetchService({ url: '/updatestocks', method: 'POST', data, ...params })
    }

    static async updatePrices({ data = undefined, ...params }) {
        return await fetchService({ url: '/updateprices', method: 'POST', data, ...params })
    }


}